<template>
  <v-row>
    <v-col cols="12" sm="6" md="4" lg="3" v-for="(item, i) in items" :key="i">
      <v-card>
        <v-img src="https://ph-test-11.slatic.net/p/a22c6d1b17b504365a141d74fd982faf.jpg"></v-img>
        <v-card-text>
          <div class="pb-3">This is a heading description for product</div>

          <span class="font-weight-bold money pink--text">&#x20B1; 150</span>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      drawer: true,
      items: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]
    };
  },
  computed: mapState(["menu"])
};
</script>
